import {OccLocaleConfig} from '@vista/omnichannel-components-ui'
import {defaultOccLocaleConfig} from '@vista/omnichannel-components-ui/lib/src/lib/context/occ/types/config/locale/locale'
import { NestedPartial } from '@vista/omnichannel-components-domain'
import { Locale } from '../../types/initialiseDataFromBe'

export function getLocaleConfigData(locale:NestedPartial<Locale>):OccLocaleConfig {

    const returnProps =  {
        ...defaultOccLocaleConfig,
        currency: {
            ...defaultOccLocaleConfig.currency,
            symbol: locale?.currency?.symbol || defaultOccLocaleConfig.currency.symbol,
            format: locale?.currency?.format || defaultOccLocaleConfig.currency.format,
            decimalSeparator: locale?.currency?.decimalSeparator || defaultOccLocaleConfig.currency.decimalSeparator,
            decimalPrecision: locale?.currency?.decimalPrecision || defaultOccLocaleConfig.currency.decimalPrecision,
            thousandsSeparator: locale?.currency?.thousandsSeparator || defaultOccLocaleConfig.currency.thousandsSeparator,
        },

        number: {
            ...defaultOccLocaleConfig.number,
            decimalSeparator: locale?.currency?.decimalSeparator || defaultOccLocaleConfig.number.decimalSeparator,
            decimalPrecision: locale?.currency?.decimalPrecision || defaultOccLocaleConfig.number.decimalPrecision,
            thousandsSeparator: locale?.currency?.thousandsSeparator || defaultOccLocaleConfig.number.thousandsSeparator,
        },
        date: {
            ...defaultOccLocaleConfig.date,
        formats: {
            ...defaultOccLocaleConfig.date.formats,
        iso: locale?.date?.formats?.iso || defaultOccLocaleConfig.date.formats.iso,
        //dateLong: locale?.date?.formats?.dateLong || defaultOccLocaleConfig.date.formats.dateLong,
        //dateShort: locale?.date?.formats?.dateShort || defaultOccLocaleConfig.date.formats.timeShort,
        },
        ianaTimeZoneName: locale?.date?.ianaTimeZoneName
        }
    }

    if(locale?.date?.formats?.dateLong) {
        returnProps.date.formats.dateLong = locale?.date?.formats?.dateLong
    }

    if(locale?.date?.formats?.dateShort) {
        returnProps.date.formats.dateShort = locale?.date?.formats?.dateShort
    }

    return returnProps
}